import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import { ThemeContext } from "../../theme/ThemeContext";

import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Toast from "../../components/ToastContainer/CustomToast";
import httpCommon from "../../config/http-common";
import { getCompanySafetyVideo } from "../../slices/SafetyVideoSlice";

export default function SafetyVideoAcknowledgement(props) {
  const { darkMode } = useContext(ThemeContext);
  const { t } = useTranslation();
  const history = useHistory();
  const [videoAcknowledged, setVideoACknowledged] = useState(false);
  const [videoURL, setVideoURL] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    loadCompanySafetyVideos();
  }, []);

  const loadCompanySafetyVideos = () => {
    let payload = {
      companyId: props?.location?.state?.companyId,
    };
    dispatch(getCompanySafetyVideo(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4000" && res.data) {
          setVideoURL(res.data[0]?.videoURL);
        }
      });
  };

  const handleSubmit = () => {
    if (!videoAcknowledged) {
      Toast(t("VIDEO_ACKNOWLEDGE_ERROR"), "error");
      return;
    }
    httpCommon
      .unsecuredAxios()
      .put("/web/visit/confirm/" + props?.location?.state?.code)
      .then((res) => {
        if (res.data.code === "CVAI0072") {
          history.push({
            pathname: "/vis/visit-success",
            state: { message: res.data.message, success: true },
          });
        } else {
          Toast(res.data.message, "error");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleChange = (event) => {
    setVideoACknowledged(event.target.checked);
  };

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          padding: "16px",
        }}
      >
        <Box
          sx={{
            paddingTop: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography variant="h3">Video View</Typography>
        </Box>

        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            paddingTop: "16px",
          }}
        >
          <ReactPlayer
            src={videoURL}
            controls={true}
            height="100%"
            width="100%"
            style={{
              objectFit: "cover",
            }}
          />
        </Box>

        <Box
          sx={{
            backgroundColor: "#fff",
            borderTop: "1px solid #ddd",
            position: "sticky",
            bottom: 0,
            paddingLeft: "16px 0px 16px 0px",
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={videoAcknowledged}
                    onChange={handleChange}
                    sx={{
                      "&.Mui-checked": { color: "rgb(242, 130, 76)" },
                      color: "#949596",
                      "&.Mui-disabled": { color: "#949596" },
                    }}
                  />
                }
                label="I have watched the video and understood the safety instructions"
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                paddingBottom: "10px",
                justifyContent: {
                  xs: "center",
                  sm: "center",
                  md: "flex-end",
                },
              }}
            >
              <SubmitButtons variant="contained" onClick={handleSubmit}>
                <Typography variant="body1" style={{ textTransform: "none" }}>
                  Confirm
                </Typography>
              </SubmitButtons>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
